/* BIO Rief – KI-Beauty-Beratung als eigenständiger Baustein (Snippet br-kibox). Beispielfragen mit fester Antwort oder Weitergabe an Tidio, sonst WhatsApp. */
(() => {
  const openTidio = text => {
    const api = window.tidioChatApi;
    if (!api) return false;
    try {
      api.show && api.show();
      api.open();
      if (text) api.messageFromVisitor(text);
      return true;
    } catch (e) { return false; }
  };
  document.querySelectorAll('[data-br-ki-solo]').forEach(box => {
    const log = box.querySelector('.br-kibox__log');
    const add = (cls, html) => {
      const p = document.createElement('p');
      p.className = cls;
      p.innerHTML = html;
      log.appendChild(p);
      log.scrollTop = log.scrollHeight;
    };
    box.querySelectorAll('.br-kibox__q[data-ask]').forEach(b => b.addEventListener('click', () => {
      const inp = box.querySelector('input'); inp.value = b.textContent.trim();
      box.querySelector('.br-kibox__form').requestSubmit(); b.disabled = true;
    }));
    box.querySelectorAll('.br-kibox__q[data-i]').forEach(b => b.addEventListener('click', () => {
      const a = box.querySelector(`[data-a="${b.dataset.i}"]`);
      add('br-kibox__me', b.textContent);
      add('br-kibox__bot', a ? a.innerHTML : '');
      b.disabled = true;
    }));
    box.querySelector('.br-kibox__form').addEventListener('submit', e => {
      e.preventDefault();
      const inp = box.querySelector('input');
      const q = inp.value.trim();
      if (!q) return;
      add('br-kibox__me', q.replace(/</g, '&lt;'));
      inp.value = '';
      if (openTidio(q)) {
        add('br-kibox__bot', 'Ich habe Ihre Frage an unseren Chat unten rechts übergeben – die Antwort erscheint dort.');
      } else {
        const wa = 'https://wa.me/4915567470469?text=' + encodeURIComponent(q);
        add('br-kibox__bot', `Der Chat lädt gerade nicht. Schreiben Sie uns gern direkt: <a href="${wa}" rel="noopener">Frage per WhatsApp senden</a>.`);
      }
    });
  });
})();
